import { useDeleteSubscriptionMutation, useGetMySubscriptionsQuery } from "api/subscriptionApi";
import { LinkButton, Text } from "components";
import { FC, useCallback } from "react";
import { Trans, useTranslation } from "react-i18next";

import { useGetCsrfTokenQuery } from "src/api";
import { showSuccessNotification } from "src/notifications";

export const DeleteSubscription: FC = () => {
    const { t } = useTranslation();

    const { data: csrfTokenResponse } = useGetCsrfTokenQuery();
    const { data: subscription } = useGetMySubscriptionsQuery();

    const [deleteSubscription] = useDeleteSubscriptionMutation();

    const onDeleteSubscription = useCallback(async () => {
        try {
            await deleteSubscription({
                csrfToken: csrfTokenResponse!.token!,
                id: subscription!.id!,
            }).unwrap();
            showSuccessNotification({
                title: t("subscriptions.delete.successTitle"),
                message: t("subscriptions.delete.successMessage"),
            });
        } catch (e) {
            // handled by global error handling
        }
    }, [csrfTokenResponse, deleteSubscription, subscription, t]);

    if (!subscription) {
        return <Text>{t("subscriptions.delete.noSubscriptions")}</Text>;
    }

    return (
        <div>
            <Trans i18nKey="subscriptions.delete.description">
                <LinkButton onClick={onDeleteSubscription} />
                <Text />
            </Trans>
        </div>
    );
};
